import * as types from '../constants/ActionTypes';

const initialState = {
  isLoading: false,
  error: false,
  cases: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_OPEN_CASE:
      return Object.assign({}, state, {
        isLoading: true,
        error: false,
        cases: [],
      });
    case types.RECEIVE_OPEN_CASE_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        error: true,
        cases: [],
      });
    case types.RECEIVE_OPEN_CASE:
      return Object.assign({}, state, {
        isLoading: false,
        error: false,
        cases: action.payload,
      });
    default:
      return state;
  }
}
